import { render } from "./PermissionEditor.vue?vue&type=template&id=333bd3f5&scoped=true&ts=true"
import script from "./PermissionEditor.vue?vue&type=script&lang=ts"
export * from "./PermissionEditor.vue?vue&type=script&lang=ts"

import "./PermissionEditor.vue?vue&type=style&index=0&id=333bd3f5&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333bd3f5"]])

export default __exports__